import React from "react";
import ContentWrapper from "../../utilities/ContentWrapper";
import CustomModal from "../../utilities/CustomModal";
import AddByeLawForm from "./AddByeLawForm";
import { useDispatch, useSelector } from "react-redux";
import {
	deleteLegalDoc,
	getLegalDocs,
} from "../../../store/actions/adminActions";
import PreviewPDF from "./PreviewPDF";
import { clearNotifications } from "../../../store/actions/notificationsActions";
import { toast } from "react-toastify";

function ByLaws() {
	const [showModal, setShowModal] = React.useState(false);
	const [displayType, setDisplayType] = React.useState();
	const [currDoc, setCurrDoc] = React.useState();
	const [loading, setLoading] = React.useState(false);

	const dispatch = useDispatch();
	const legalDocs = useSelector((state) => state.admin.legalDocs);

	function handleHideModal() {
		setShowModal(false);
	}

	function handleShowModal(type, fileLoc) {
		setShowModal(true);
		setDisplayType(type);
		setCurrDoc(fileLoc);
	}

	function handleDeleteDoc(id) {
		dispatch(deleteLegalDoc(id));
	}

	const notification = useSelector((state) => state.notification);

	React.useEffect(() => {
		setLoading(false);
		if (notification.success?.message) {
			toast.success(notification.success?.message);

			dispatch(getLegalDocs());
			dispatch(clearNotifications());

			handleHideModal();
		}
		if (notification.errors?.message) {
			toast.error("failed");
		}
		dispatch(clearNotifications());
	}, [
		dispatch,
		notification.errors?.message,
		notification.success?.message,
		setLoading,
	]);

	React.useEffect(() => {
		dispatch(getLegalDocs());
	}, [dispatch]);

	return (
		<ContentWrapper>
			<div className='card' id='cart'>
				<div className='row'>
					<div className='col-md-12 cart'>
						<div className='title d-flex'>
							<div className='col'>
								<h4>
									<b>Legals</b>
								</h4>
							</div>
							<button
								className='check-out-btn col-lg-3'
								onClick={() => handleShowModal("form")}>
								ADD LEGAL DOC
							</button>
						</div>
					</div>

					<div className='col-md-12 cart'>
						{legalDocs.length > 0 ? (
							legalDocs.map((doc) => (
								<div className='row border-top border-bottom p-2' key={doc._id}>
									<div className='row main align-items-center'>
										<div className='col'>
											<div className='row text-muted'>
												{doc.docName.toUpperCase()}
											</div>
										</div>
										<div className='col'>
											{" "}
											<div className='row'>{doc.description}</div>
										</div>
										<div className='col' role='button'>
											<span
												className='close text-success'
												onClick={() => handleShowModal("preview", doc)}>
												preview
											</span>
										</div>
										<div
											className='col'
											role='button'
											onClick={() => handleDeleteDoc(doc._id)}>
											<span className='close text-danger'>remove item</span>
										</div>
									</div>
								</div>
							))
						) : (
							<h4>No Doc has been uploaded</h4>
						)}
					</div>
				</div>
			</div>
			<CustomModal
				hide={handleHideModal}
				show={showModal}
				size={displayType === "form" ? "md" : "xl"}
				title={displayType === "form" ? "ADD LEGAL DOC" : "PREVIEW DOC"}>
				{displayType === "form" && (
					<AddByeLawForm loading={loading} setLoading={setLoading} />
				)}
				{displayType === "preview" && (
					<PreviewPDF file={currDoc.legalDocFile.file_location} />
				)}
			</CustomModal>
		</ContentWrapper>
	);
}

export default ByLaws;
